"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _instance = _interopRequireDefault(require("./instance"));

/**
 * Utilities for working with a registry that holds instances of APIs.
 * @module APIRegistry
 */
var APIUtilsRegistry = /*#__PURE__*/function () {
  function APIUtilsRegistry() {
    (0, _classCallCheck2.default)(this, APIUtilsRegistry);
    this._instances = {};
    this.create();
  }
  /**
   * Creates a named instance of APIUtils.
   * @static
   * @function create
   * @param {String} name - The name used to reference this instance when retrieving it from the registry.
   * @param {Object} config - The configuration object. See <a href="module-APIUtils.html#.init">APIUtils.init()</a>.
   * @example
   * APIRegistry.create({
   *     name: 'services',
   *     config: {
   *         baseUrl: 'api/v1'
   *     }
   * });
   * @returns {AxiosInstance} - The axios instance.
   */


  (0, _createClass2.default)(APIUtilsRegistry, [{
    key: "create",
    value: function create() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$name = _ref.name,
          name = _ref$name === void 0 ? 'default' : _ref$name,
          config = _ref.config;

      if (this._instances[name]) {
        var _context;

        throw new Error((0, _concat.default)(_context = "An instance with the name ".concat(name, " already exists. Use APIRegistry.get('")).call(_context, name, "') to retrieve it."));
      }

      this._instances[name] = new _instance.default(config);
      return this._instances[name];
    }
    /**
     * Retrieves the specified instance from the registry.
     * @static
     * @function get
     * @param {String} name - The name of the instance to retrieve.
     * @example
     * const serviceInstance = APIRegistry.get('services');
     * @returns {AxiosInstance} - The axios instance.
     */

  }, {
    key: "get",
    value: function get(name) {
      return this._instances[name];
    }
  }]);
  return APIUtilsRegistry;
}();

var _default = APIUtilsRegistry;
exports.default = _default;